var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messageInfo"},[(_vm.info)?_c('div',{staticClass:"messageInfo-wrapper"},[_c('p',{staticClass:"newsTitle"},[_vm._v(_vm._s(_vm.info.Title))]),_c('p',{staticClass:"newsPreview"},[_vm._v(_vm._s(_vm.info.MessageContent))]),_c('p',{staticClass:"newsBottom"},[_vm._v(_vm._s(_vm.info.ReleaseTime))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }